export const patientSearchTemplate = `<div class="pdf-container">
  <style>
    div.pdf-container {
      font-family: Arial, Helvetica, sans-serif;
      font-size: 15px;
    }

    div.pdf-container table {
      width: 100%;
      margin-top: 30px;
    }

    div.pdf-container table,
    div.pdf-container th,
    div.pdf-container td {
      border: 1px solid #c0c0c0;
      border-collapse: collapse;
    }

    div.pdf-container tr.table-header {
      background-color: #4682b4;
      color: white;
    }

    div.pdf-container th,
    div.pdf-container td {
      padding: 2px 5px 2px 5px;
      text-align: left;
    }

    div.pdf-container th {
      font-weight: normal;
      font-size: 13px;
    }

    div.pdf-container td {
      font-size: 11px;
    }

    div.pdf-container div {
      margin-bottom: 10px;
    }

    div.pdf-container img {
      width: 15px;
      margin: 0px 2px;
    }

    div.pdf-container td.preferencias {
      text-align: center;
    }
  </style>
  <div>Exportación de pacientes</div>
  <div>Óptica: {{OPTICA}}</div>
  <table>
    <tr class="table-header">
      <th>Código</th>
      <th>Nombre</th>
      <th>Apellidos</th>
      <th>Preferencias</th>
      <th>Dirección</th>
      <th>Localidad</th>
      <th>Teléfono</th>
      <th>Email</th>
    </tr>
    {{ROW}}
  </table>
</div>`;
